<template>
  <div :class="mainClass">
    <div class="row">
      <div class="col-12">
        <div class="mb-3">
          <em class="icon-shadowed fas fa-clock text-orange" />
          <span class="color-gray-7 font-16 font-weight-bold ml-2 mb-2">
            Historial de Bitácora
          </span>
        </div>
        <custom-result-not-found
          v-if="history.length == 0"
          class="mt-4 row pt-3"
          text="No hay Información Disponible."
        />
        <custom-callout
          v-for="(item, index) in list"
          :key="index"
          class="mb-3 custom-callout"
          :has-border="false"
          :has-gradient="false"
          :has-toggle="false"
        >
          <div class="row py-3 m-0 pr-4">
            <div class="col-12 col-lg-2 col-md-3 border-right">
              <div class="row ">
                <div class="col-12 mb-3">
                  <custom-balloon
                    :background-color="item.statusColor"
                    class="mt-2"
                    :text="item.statusName"
                    dot
                  />
                </div>
                <div class="col-12 mb-2">
                  <div
                    class="color-secondary-6 font-14 font-weight-normal mr-2"
                  >
                    Fecha:
                  </div>
                  <div class="color-black font-16 font-weight-bold">
                    {{ item.createdDate | date }}
                  </div>
                  <div class="color-black font-14 font-weight-normal">
                    {{ item.createdDate | hour }}
                  </div>
                </div>
                <div class="col-12">
                  <div
                    class="color-secondary-6 font-14 font-weight-normal mr-2"
                  >
                    Añadido por:
                  </div>
                  <div class="color-black font-16 font-weight-bold">
                    {{ item.createdBy }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-10 col-md-9">
              <div class="row ml-lg-3">
                <div class="col-12 mb-2">
                  <div
                    class="color-secondary-6 font-14 font-weight-normal mr-2"
                  >
                    Comentario:
                  </div>
                  <div class="color-black font-16 font-weight-normal">
                    {{ item.comment | empty }}
                  </div>
                </div>
                <div class="col-12">
                  <div class="row bg-white rounded p-3">
                    <div
                      class="col-12 col-md-3 mb-2 mb-lg-0"
                      v-if="item.classificationName"
                    >
                      <div
                        class="color-secondary-6 font-14 font-weight-normal mr-2"
                      >
                        Clasificación:
                      </div>
                      <div class="color-black font-16 font-weight-normal">
                        {{ item.classificationName | empty }}
                      </div>
                    </div>
                    <div class="col-12 col-md-4 mb-2 mb-lg-0">
                      <div
                        class="color-secondary-6 font-14 font-weight-normal mr-2"
                      >
                        Asunto:
                      </div>
                      <div class="color-black font-16 font-weight-normal">
                        {{ item.documentName | empty }}
                      </div>
                    </div>
                    <div
                      class="col-12 mb-2 mb-lg-0"
                      :class="{
                        'col-md-6': !item.classificationName,
                        'col-md-4': item.classificationName,
                      }"
                    >
                      <div
                        class="color-secondary-6 font-14 font-weight-normal mr-2"
                      >
                        Archivo:
                      </div>
                      <div class="color-black font-16 font-weight-normal">
                        {{ item.fileName | empty }}
                      </div>
                    </div>
                    <div class="col-12 col-md-1">
                      <action-button
                        v-if="canDownloadFile(item)"
                        variant="success"
                        i="fas fa-file-download"
                        @click="() => downloadFile(item)"
                      ></action-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </custom-callout>
      </div>
    </div>
    <div class="row" v-if="history.length">
      <div class="col text-center">
        <action-button
          v-if="showMore"
          variant="outline-success custom-view-more actionButton"
          i="fas fa-chevron-down"
          @click="handlerMore"
        >
          Ver más
        </action-button>
      </div>
    </div>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import CustomBalloon from 'custom-balloon';
import CustomResultNotFound from 'custom-result-not-found';
import documentsService from '@/services/api/document.api';
import peiATServiceStatus from '@/utils/constants/peiATServiceStatus';

export default {
  name: 'BinnacleHistory',
  components: {
    CustomCallout,
    ActionButton,
    CustomBalloon,
    CustomResultNotFound,
  },
  props: {
    history: {
      type: Array,
      default: () => [],
    },
    mainClass: {
      type: String,
      default: 'bg-white rounded',
    },
  },
  data() {
    return {
      count: 2,
    };
  },
  computed: {
    showMore() {
      return this.history.length > this.count && this.history.length > 2;
    },
    list() {
      const items = this.history.slice(0, this.count);
      return items;
    },
    canDownloadFile() {
      return (item) => Boolean(item.documentId);
    },
  },
  methods: {
    async downloadFile({ documentId }) {
      await documentsService.downloadFromServer(documentId);
    },
    handlerMore() {
      this.count += 2;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ab-btn {
  border-radius: 19px !important;
}
</style>
